import { useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@skaleminds/jig-auth-sdk-ui';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { clearReturnTo } from '@/lib/return-to';

/** Ends the session, drops cached user data (and any pending shared-link return) and returns to the login page. */
export function useSignOut(): () => Promise<void> {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  return useCallback(async () => {
    await logout();
    queryClient.clear();
    clearReturnTo();
    navigate('/login', { replace: true });
  }, [logout, navigate, queryClient]);
}
